import React, { Component } from "react";
import firebase from "../firebase";
import { Link } from "react-router-dom";
import Sidebar from "../includes/Sidebar";

export default class Home extends Component {
  state = {
    pageId: null,
    title: localStorage.homeTitle ? localStorage.homeTitle : "",
    content: localStorage.homeContent ? localStorage.homeContent : "",
    bannerUrl: localStorage.bannerUrl ? localStorage.bannerUrl : "",
    bannerTitle: localStorage.bannerTitle ? localStorage.bannerTitle : "",
    bannerContent: localStorage.bannerContent ? localStorage.bannerContent : ""
  };

  componentDidMount() {
    firebase
      .database()
      .ref("/pages")
      .on("value", snap => {
        let val = snap.val();
        val.map((el, idx) => {
          if (el.isHome === "true") {
            this.setState({ pageId: idx }, () => this.fetchHomePage());
          }
          return null;
        });
      });
    let banner = firebase.database().ref("banner");
    banner.on("value", snap => {
      this.setState({ bannerUrl: snap.val() }, () => {
        localStorage.bannerUrl = snap.val();
      });
    });
    let bannerTitle = firebase.database().ref("bannerTitle");
    bannerTitle.on("value", snap => {
      this.setState({ bannerTitle: snap.val() }, () => {
        localStorage.bannerTitle = this.state.bannerTitle;
      });
    });
    let bannerContent = firebase.database().ref("bannerContent");
    bannerContent.on("value", snap => {
      this.setState({ bannerContent: snap.val() }, () => {
        localStorage.bannerContent = this.state.bannerContent;
      });
    });
  }

  fetchHomePage = () => {
    let home = firebase.database().ref(`/pages/${this.state.pageId}`);
    home.on("value", snap => {
      let val = snap.val();
      this.setState({ title: val.title, content: val.content }, () => {
        localStorage.homeTitle = val.title;
        localStorage.homeContent = val.content;
      });
    });
  };

  componentWillUnmount() {
    firebase
      .database()
      .ref()
      .off();
  }

  toHtml = html => {
    return { __html: html };
  };

  render() {
    let { bannerTitle, bannerContent } = this.state;
    let banner = (
      <div
        className="banner-container"
        style={{ backgroundImage: `url(${this.state.bannerUrl})` }}
      >
        <div className="banner-content wrap">
          <h1>{bannerTitle}</h1>
          <p className="banner-text">{bannerContent}</p>
          <Link to="/services">
            <span>
              Learn More <i className="fas fa-caret-right" />
            </span>
          </Link>
        </div>
      </div>
    );

    let title = <h1 className="page-title">{this.state.title}</h1>;

    let content = (
      <article className="page-content col-xs-12 col-sm-6 col-lg-8">
        <div dangerouslySetInnerHTML={this.toHtml(this.state.content)} />
      </article>
    );

    return (
      <main className="main home">
        <section className="home-content-container">
          {banner}
          <section className="content-inner wrap clearfix">
            {title}
            {content}
            <Sidebar />
          </section>
        </section>
      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home.js